import NextImage from 'next/image';

export const BzEverywhere = ({ priority = false }: { priority?: boolean }) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 md:py-10 py-4 items-center justify-center mx-auto">
      <div className="w-full md:w-1/2 relative aspect-[4/3]">
        <NextImage
          alt="Bz Everywhere"
          className="object-contain"
          fill
          priority={priority}
          src="/next-assets/images/portfolio/bz-everywhere.png"
        />
      </div>
      <div className="w-full md:w-1/2 flex flex-col gap-4 px-4">
        <h3 className="md:text-4xl text-2xl font-bold">Create your portfolio once.</h3>
        <h4 className="md:text-2xl text-lg font-bold">Then take it everywhere!</h4>
        <ul className="list-disc list-inside md:text-sm text-base">
          <li>
            <strong>Track all</strong> your favorite stocks.
          </li>
          <li>
            Get the <strong>latest news</strong> relevant to your tickers.
          </li>
          <li>
            See <strong>insider trades</strong> happening on your stocks.
          </li>
          <li>
            Follow <strong>calendar events</strong> to stay ahead of the curve.
          </li>
          <li>
            Get the <strong>most up-to-date info</strong> on the companies you follow.
          </li>
        </ul>
        <a
          className="text-white bg-orange-500 px-4 py-2 rounded-sm w-fit"
          href="https://www.benzinga.com/login?action=login&next=/profile/portfolio&utm_source=portfolio"
          rel="noopener noreferrer"
        >
          Start Now
        </a>
      </div>
    </div>
  );
};
